export const folderItemNameMaxLines = 2;
export const folderItemNameSizeREM = 0.875; // maps to the default size for Typograpgy (variant=body2 and value is 0.875rem)
export const folderItemNameLineHeight = 1.15; // also grabbed from the default Typography line-height value

export const folderItemIconSize = 68;
export const folderItemHeight = 96;